export default function reducer(state={
    about:[]
},action){
switch(action.type){
    case "STORE_ABOUT_US_DETAILS":{
        return{...state,
            about: action.list.about
        }
    }
    default:
        break;
}
return state
}